import {formatRelative} from 'date-fns'
import {isEmpty} from './tools'

export const filterRecordsByAttribute = ({records = [], attribute, id}) => records.filter(record => record[attribute] === id)

export const findRecordByAttribute = ({records = [], attribute, id}) => records.find(record => record[attribute] === id) || {}

export const filterNotRecords = ({records = [], id}) => records.filter(record => record.id !== id)

export const formatDate = (date = (new Date())) => formatRelative(date, new Date())

export const formatTableData = ({column, data}) => {
  if (column.boolean)
    return `${data ? 'Yes' : 'No'}`
  else if (column.date)
    return formatDate(data)
  else
    return data
}

export const snakeToCamel = inputString => {
  if (!inputString) return ''

  return inputString.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
}

export const formatCamelCase = inputString => {
  if (!inputString) {
    return '';
  }

  // Use regex to split the string at each capital letter.
  // The (?=[A-Z]) is a positive lookahead that finds the position
  // right before a capital letter.
  const words = inputString.split(/(?=[A-Z])/);

  // Map over the array of words, capitalize the first letter of each,
  // and join them with a space.
  const formattedString = words
    .map(word => {
      // Capitalize the first letter and add the rest of the word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' '); // Join all the words with a space

  return formattedString
}

export const isString = data => Object.keys(data).length === data.length

// Some endpoints answer with a message and no record at all — releasing a key share, finishing a
// recovery — and there is nothing in that for a collection to absorb.
const hasRecord = data => Boolean(data)

export const stateValue = ({data, records}) => {
  if (!hasRecord(data))
    return records
  else if (Array.isArray(data))
    return data
  else if (isString(data))
    return filterNotRecords({records, id: data})
  else
    return [...filterNotRecords({records, id: data.id}), data]
}

export const stateMeta = ({data, meta = {}, prevMeta = {}}) => {
  if (!hasRecord(data))
    return prevMeta

  if (Array.isArray(data))
    return {...prevMeta, ...meta}

  if (isEmpty(prevMeta)) {
    if (isString(data))
      return {count: 0}
    else
      return {count: 1}
  } else {
    if (isString(data))
      return {...prevMeta, count: (prevMeta.count - 1)}
    else
      return {...prevMeta, count: (prevMeta.count + 1)}
  }
}
